import { CloseOutlined } from '@ant-design/icons';
import useOrgAccess from '_/hooks/useOrgAccess';
import { formatWrittenDate } from '_/utils/dateUtils';
import { SOURCE_ENGINEER_NOT_INCLUDED } from '_/utils/userManagement';
import { Button, Modal, Typography, Tooltip } from 'antd';
import Markdown from 'markdown-to-jsx';
import React, { ReactElement } from 'react';

interface VersionAfter {
  content?: string;
}

interface VersionData {
  after?: VersionAfter;
  currentVersion?: boolean;
  isCurrentVersion?: boolean;
  timestamp?: string;
}

interface VersionPreviewModalProps {
  canEdit?: boolean;
  onCancelClick?: (data: Record<string, never>) => void;
  onRestoreClick?: (versionData: VersionData) => void;
  open: boolean;
  versionData?: VersionData;
}

function VersionPreviewModal({
  canEdit,
  onCancelClick,
  onRestoreClick,
  open,
  versionData = {},
}: VersionPreviewModalProps): ReactElement {
  const access = useOrgAccess(SOURCE_ENGINEER_NOT_INCLUDED);
  const disabled = !access && !canEdit;

  const handleRestore = (e: React.MouseEvent) => {
    e.preventDefault();

    if (onRestoreClick) {
      onRestoreClick(versionData);
    }
  };

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onCancelClick) {
      onCancelClick({});
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      // width="100%"
      // style={{ top: 0, paddingBottom: 0, maxWidth: '100vw' }}
      // styles={{ body: { height: 'calc(100vh - 110px)', overflow: 'auto', padding: '24px' } }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography.Title level={5} style={{ margin: 0 }}>
            Preview Version ({formatWrittenDate(versionData?.timestamp) || ''})
          </Typography.Title>
        </div>
      }
      footer={
        !versionData.currentVersion &&
        !versionData.isCurrentVersion && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Tooltip
              title={access || canEdit ? 'Restore Readme' : 'You do not have the right permissions to restore this readme'}
            >
              <span>
                <Button autoFocus danger type="primary" disabled={disabled} onClick={handleRestore}>
                  Restore
                </Button>
              </span>
            </Tooltip>
          </div>
        )
      }
      closeIcon={<CloseOutlined />}
    >
      <Markdown>{versionData?.after?.content || ''}</Markdown>
    </Modal>
  );
}

export default VersionPreviewModal;
